import AOS from 'aos';

window.addEventListener('load', () => {
    AOS.init();
});
